<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.maindynamic
	background:#F9F9F9;
	padding-bottom:150px;
	.top
		width:100%;
		height:492px;
		position: relative;
		background:url('../../../static/img/dynamicInformation.png') no-repeat;
		background-size: 100% 100%;
		.top-main
			position: absolute;
			bottom:50px;
			right:90px;
			color:#fff;
			font-size:42px;
	.center
		text-align:center;
		padding:55px 0px;
		.c-title
			border-bottom:1px solid #CECECE;
			font-size:22px;
			font-weight: 500;
			color:#000000;
		.c-title-english
			color:#8D8D8D;
			height:20px;
			line-height:20px;
			font-size: 14px;
	.info
		.info-list
			cursor:pointer;
			margin:30px auto;
			width:1538px;
			background:#FFFFFF;
			border-radius:10px;
			display:flex;
			padding:47px 200px 47px 274px;
			.info-img
				width:332px;
				height:192px;
				margin-right:30px;
			.info-right
				width:70%;
				.info-r-title
					color:#000000;
					font-size:28px;
					font-weight:bold;
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
				.info-r-content
					color:#666666;
					height:85px;
					font-size:14px;
					margin-top:20px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					line-clamp: 4;
					-webkit-line-clamp: 4;
					-webkit-box-orient: vertical;
					word-wrap: break-word;
				.info-r-bottom
					margin-top:20px;
					color:#333333;
					font-size:12px;
					display:flex;	
					div
						margin-right:15px;	
	.infoObj
		margin:30px auto;
		width:1538px;
		border-radius:10px;
		background:#FFFFFF;
		padding:47px 120px;
		.infoObj-list
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			.infoObj-lists
				width: 45%;
				margin-bottom:30px;
				line-height: 22px;
				flex: none;
				display: flex;
				justify-content: space-between;
				align-items:center;
				cursor:pointer;
				.infoObj-top
					width:80%;
					color:#333333;
					font-size:16px;
					display:flex;
					align-items:center;
					.dot
						width:4px;
						height:4px;
						background:#0E2053;
						border-radius:50%;
						margin-right:5px;
					.infoObj-title
						width:95%;
						overflow:hidden;
						text-overflow:ellipsis;
						white-space:nowrap;
				.infoObj-time
					color:#A4A4A4;
					line-height:20px;
					font-size:14px;
		.infoObj-page
			margin:40px 0;
			text-align:center;
</style>
<template>
  <div class="maindynamic">
    <div class="top">
    	<div class="top-main">
    		<div>INFORMATION</div>
    		<div>律师行业动态信息,尽在其中</div>
    	</div>
    </div>
    
    <div class="center">
    	<div class="c-title">行业资讯</div>
    	<div class="c-title-english">Industry information</div>
    </div>

    <div class="info">
    	<div v-for="(item,index) in infoList" class="info-list" @click="$router.push({name: 'post', params: {post_id: item.pid}})">
    		<div>
    			<img :src="item.thumb" class="info-img">
    		</div>
    		<div class="info-right">
    			<div class="info-r-title">{{item.title}}</div>
    			<div class="info-r-content" v-html="item.summary"></div>
    			<div class="info-r-bottom">
    				<div>{{item.created_at}}</div>
    				<div>阅读数：{{item.pv_num}}</div>
    			</div>
    		</div>
    	</div>
    </div>

    <div class="infoObj">
    	<div class="infoObj-list">
    		<div v-for="(item,index) in infoObj.list" class="infoObj-lists" @click="$router.push({name: 'post', params: {post_id: item.pid}})">
    			<div class="infoObj-top">
    				<div class="dot"></div>
    				<div class="infoObj-title">{{item.title}}</div>
				</div>
    			<div class="infoObj-time">{{item.created_at | timeconvert}}</div>
    		</div>
    	</div>
    	<div class="infoObj-page">
    		<el-pagination
	          background
	          layout="prev, pager, next, total"
	          @current-change="pageChange"
	          :current-page.sync="infoObj.page"
	          :page-size="infoObj.perpage"
	          :total="infoObj.total">
	        </el-pagination>
    	</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'dynamicInformation',
  data () {
    return {
      infoList:[],
      infoObj: {
        list: [],
        page: 1,
        perpage: 12,
        total: 0
      },
    }
  },
  mounted(){
  	this.getTopInfoList();
  	this.getInfoList();
  },
  methods:{
  	getTopInfoList() {
      this.$ajax('get', 'industryinformation/topindustryinformation', data => {
        this.infoList = data.data;
      }, err => {});
    },
    getInfoList() {
      this.$ajax('get', 'industryinformation/industryinformationlist', {page: this.infoObj.page, perpage: this.infoObj.perpage},  data => {
        this.infoObj.list = data.data.data;
        this.infoObj.total = data.data.total;
      }, err => {});
    },
    pageChange(page) {
      this.getInfoList();
    },
  },
  filters: {
    timeconvert(date) {
      return moment(date).format('YYYY-MM-DD');
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/aboutHonsen/dynamicInformation.vue